module.exports = __webpack_public_path__ + "img/sweden.1e0847fa.svg";